import { useCallback, useState } from "react";
// import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import { injectIntl } from "react-intl";
import { useDropzone } from "react-dropzone";
import {
  Space,
  // Attachment,
  // AttachmentsList
} from "@masterteam/mt-design-react";
import Attachments from "../AttachmentsList";
import Attachment from "../AttachmentsList/Attachment";
import { ReactComponent as PlusIcon } from "../../assets/images/plus-symbol.svg";
// import { formatBytes } from "../../helpers";
import { addToast } from "../../helpers";
import styles from "./Upload.module.scss";

const cx = classNames.bind(styles);

function nameCharactersValidator(file) {
  if (/[#%*:<>/?\\|]/g.test(file.name)) {
    return {
      code: "name-invalid-character",
      message: `File name has invalid characters`,
    };
  }

  return null;
}

const Upload = ({
  label,
  onChange,
  loading,
  disabled,
  onDelete,
  attachments = [],
  multiple = false,
  maxSize,
  error,
  intl,
  ...otherProps
}) => {
  const [progress, setProgress] = useState(0);
  // const [t] = useTranslation();
  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      if (acceptedFiles?.length) {
        onChange(
          multiple
            ? [
                ...attachments,
                ...acceptedFiles.map((item) => ({
                  ...item,
                  preview: URL.createObjectURL(item),
                  FileName: item.name,
                  file: item,
                })),
              ]
            : {
                ...acceptedFiles[0],
                preview: URL.createObjectURL(acceptedFiles[0]),
                FileName: acceptedFiles[0].name,
                file: acceptedFiles[0],
              }
        );
        // setProgress(1);
        // uploadFiles(acceptedFiles, {
        //   onUploadProgress: prog => {
        //     setProgress((prog.loaded / prog.total) * 100);
        //   }
        // }).then(res => {
        //   onChange(multiple ? [...attachments, ...res.data] : res.data);
        //   setProgress(0);
        //   // setFiles([
        //   //   {
        //   //     ...res.data,
        //   //     preview: URL.createObjectURL(acceptedFiles[0]),
        //   //   },
        //   // ]);
        // });
      }
      if (fileRejections?.length) {
        // this line is because accept files is not working on some browsers
        fileRejections.forEach((file) => {
          addToast.error(
            intl.formatMessage(
              { id: `upload-error.${file.errors[0].code}` },
              {
                value: file.file.name,
              }
            ),
            {
              toastId: "upload-error",
            }
          );
        });
      }
    },
    [onChange]
  );

  const deleteAttachment = (file) => {
    if (multiple) {
      const newFiles = attachments.filter(
        (item) => JSON.stringify(item) !== JSON.stringify(file)
      );
      return onDelete(newFiles);
    }
    return onDelete(file);
  };

  // useEffect(() => () => {
  //   files.forEach((file) => URL.revokeObjectURL(file.preview));
  // });

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    disabled: progress || disabled || loading,
    validator: nameCharactersValidator,
    // noDrag: true,
    multiple,
    maxSize,
    ...otherProps,
  });

  return (
    <Space direction="vertical" className={styles.upload}>
      <label className={styles.label}>{label || "‎"}</label>
      {!attachments || multiple ? (
        <>
          <div
            {...getRootProps()}
            className={cx({
              input: true,
              error,
              wide: progress || attachments,
            })}
            style={{ "--progress": `${progress}%` }}
          >
            <input {...getInputProps()} />
            <PlusIcon />
          </div>
          {maxSize ? (
            <div style={{ fontSize: "var(--font-small)" }}>
              max size
              {
                //   t("common:validations:file-max-size", {
                //   value: formatBytes(maxSize)
                // })
              }
            </div>
          ) : null}
        </>
      ) : null}

      {Array.isArray(attachments) ? (
        <Attachments
          files={attachments}
          onDelete={!disabled && deleteAttachment}
        />
      ) : (
        <Attachment
          file={attachments}
          onDelete={!disabled && deleteAttachment}
        />
      )}
    </Space>
  );
};

export default injectIntl(Upload);
